import { mapState } from "pinia";
import { useGeneralStore } from "%/stores/general-store";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import { DynamicEntityMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-entity-mixin";
import { OptionCalculationMixin } from "%/dynamic-components/render-engine/mixins/production/option-calculation-mixin";
import AnimationOptions from "%/dynamic-components/render-engine/bundles/animations-options";
import DynamicComponentError from "%/errors/dynamic-component-error";
import AnimationEffectsOptions from "%/dynamic-components/render-engine/bundles/animation-effects-options";
import DynamicComponent from "%/dynamic-components/render-engine/classes-v2/dynamic-component";
import useFanPublicationStore from "%/stores/fan-publication-store";

export const DynamicElementMixin = {
  isDynamicComponentElement: true,
  mixins: [
    OptionCalculationMixin,
    DynamicEntityMixin,
  ],
  inject: {
    activeComponentId: {
      default: null,
    },
  },
  props: {
    entityId: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    configuration: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    identifier: {
      type: String,
      required: false,
      default: "",
    },
    overrides: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    editMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    breakpoint: {
      type: String,
      required: false,
      default: "",
    },
  },
  optionBundles: [
    AppearanceOptions,
    AnimationOptions,
    AnimationEffectsOptions,
  ],
  defaultElementPanelSettings: {
    displayIcon: "message",
    elementType: "element",
  },
  created() {
    this.assertValidElement();
  },
  mounted() {
    if (this.editMode) {
      const component = this.$el;
      if (component.style) {
        component.style.cursor = "pointer";
      }
    }
  },
  computed: {
    ...mapState(useGeneralStore, ["links"]),
    dynamicComponentInstance() {
      return DynamicComponent.get(
        this.activeComponentId,
        useFanPublicationStore().publicationId,
      );
    },
  },
  methods: {
    assertValidElement() {
      if (this.$options.production) {
        return true;
      }

      const elementPanelSettings = this.$options.elementPanelSettings;
      if (typeof elementPanelSettings !== "object" || elementPanelSettings === null) {
        throw new DynamicComponentError("Dynamic component element must define a valid elementPanelSettings object", {
          componentName: this.$options.name,
        });
      }
      if (
        !Object.prototype.hasOwnProperty.call(elementPanelSettings, "displayIcon")
      ) {
        elementPanelSettings.displayIcon = this.$options.defaultElementPanelSettings.displayIcon;
      }
      if (
        !Object.prototype.hasOwnProperty.call(elementPanelSettings, "elementType")
      ) {
        elementPanelSettings.elementType = this.$options.defaultElementPanelSettings.elementType;
      }
    },
  },
};
